import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, AuthCallback } from './context/AuthContext';
import Layout from './components/Layout';
import CookieBanner from './components/CookieBanner';
import InstallPWABanner from './components/InstallPWABanner';
import HomePage from './pages/HomePage';
import TarotPage from './pages/TarotPage';
import AstrologyPage from './pages/AstrologyPage';
import NumerologyPage from './pages/NumerologyPage';
import IchingPage from './pages/IchingPage';
import CreditsPage from './pages/CreditsPage';
import DashboardPage from './pages/DashboardPage';
import StatsPage from './pages/StatsPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import SharedPage from './pages/SharedPage';
import ReferralRedirectPage from './pages/ReferralRedirectPage';
import SynastryPage from './pages/SynastryPage';
import { PrivacyPage, TermsPage } from './pages/LegalPages';
import ReviewerAccessPage from './pages/ReviewerAccessPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import './App.css';

const AppRouter = () => (
  <Routes>
    {/* Referral redirect - short link */}
    <Route path="/r/:code" element={<ReferralRedirectPage />} />

    {/* Public pages without layout */}
    <Route path="/login" element={<LoginPage />} />
    <Route path="/admin" element={<AdminPage />} />
    <Route path="/shared/:id" element={<Layout><SharedPage /></Layout>} />

    {/* Pages with layout */}
    <Route path="/" element={<Layout><HomePage /></Layout>} />
    <Route path="/tarot" element={<Layout><TarotPage /></Layout>} />
    <Route path="/astrology" element={<Layout><AstrologyPage /></Layout>} />
    <Route path="/synastry" element={<Layout><SynastryPage /></Layout>} />
    <Route path="/numerology" element={<Layout><NumerologyPage /></Layout>} />
    <Route path="/iching" element={<Layout><IchingPage /></Layout>} />
    <Route path="/credits" element={<Layout><CreditsPage /></Layout>} />
    <Route path="/dashboard" element={<Layout><DashboardPage /></Layout>} />
    <Route path="/stats" element={<Layout><StatsPage /></Layout>} />
    <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
    <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
    <Route path="/reviewer-access" element={<ReviewerAccessPage />} />
    <Route path="/delete-account" element={<Layout><DeleteAccountPage /></Layout>} />

    {/* Auth callback */}
    <Route path="/auth/callback" element={<AuthCallback />} />
  </Routes>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <CookieBanner />
        <InstallPWABanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
